import React, { useState } from "react";
import { BiBarChartAlt2, BiTrendingUp, BiUser, BiMoney, BiSearch, BiReceipt, BiTransfer, BiRefresh } from "react-icons/bi";
import DashboardOverview from "./components/DashboardOverview";
import TransactionInsights from "./components/TransactionInsights";
import PartnerAnalytics from "./components/PartnerAnalytics";
import GeneralPartnerAnalytics from "./components/GeneralPartnerAnalytics";
import ChargesAnalytics from "./components/ChargesAnalytics";
import InternalSettlement from "./components/InternalSettlement";
import Refunds from "./components/Refunds";
import { AccountStatusSearch } from "../../components/AccountStatusSearch";
import { ThemeContext } from "../../themes/ThemeContext";

const AnalyticsPage = () => {
  const theme = React.useContext(ThemeContext);
  const [activeTab, setActiveTab] = useState("charges");

    const tabs = [
    // {
    //   id: "overview",
    //   label: "Dashboard Overview",
    //   icon: BiBarChartAlt2,
    //   component: DashboardOverview,
    // },
    // {
    //   id: "transactions",
    //   label: "Transaction Insights",
    //   icon: BiTrendingUp,
    //   component: TransactionInsights,
    // },
    // {
    //   id: "partners",
    //   label: "Partner Analytics",
    //   icon: BiUser,
    //   component: GeneralPartnerAnalytics,
    // },
    // {
    //   id: "partner-search",
    //   label: "Partner Search",
    //   icon: BiSearch,
    //   component: PartnerAnalytics,
    // },
    {
      id: "charges",
      label: "Charges Analytics",
      icon: BiMoney,
      component: ChargesAnalytics,
    },
    {
      id: "account-status",
      label: "Account Status Search",
      icon: BiReceipt,
      component: AccountStatusSearch,
    },
    {
      id: "internal-settlement",
      label: "Internal Settlement",
      icon: BiTransfer,
      component: InternalSettlement,
    },
    {
      id: "refunds",
      label: "Refunds",
      icon: BiRefresh,
      component: Refunds,
    },
  ];

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen p-6" style={{ backgroundColor: theme?.colors?.background?.primary || '#1a1a1a' }}>
      {/* Header Section */}
      <div className="mb-12">
        <div className="flex items-center space-x-3 mb-4">
          {/* <BiMoney className="text-3xl" style={{ color: theme.colors.text.primary }} /> */}
          <h1 className="text-3xl font-bold" style={{ color: theme.colors.text.primary }}>
            Business Intelligence Dashboard
          </h1>
        </div>
        <p className="text-gray-400 max-w-2xl">
          Comprehensive analytics and insights for monitoring business performance, transaction patterns, and partner engagement.
        </p>
      </div>

      {/* Navigation Tabs */}
      <div className="mb-12">
  <div className="flex flex-wrap gap-2 border-b border-gray-700">
    {tabs.map((tab) => {
      const IconComponent = tab.icon;
      const isActive = activeTab === tab.id;

      return (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex items-center space-x-2 px-6 py-3 rounded-t-lg font-medium transition-all duration-200 ${
            isActive
              ? "text-white"
              : "text-gray-400 hover:text-white hover:bg-gray-700"
          }`}
          style={
            isActive
              ? {
                  background:
                    "linear-gradient(270deg, rgb(75, 73, 172) 0.05%, rgb(153, 153, 255) 99.97%)",
                }
              : {}
          }
        >
          <IconComponent className="w-5 h-5" />
          <span>{tab.label}</span>
        </button>
      );
    })}
  </div>
</div>


      {/* Content Section */}
      <div className="space-y-8">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default AnalyticsPage; 